// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "vertexColorMixing";
const shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;#else
vColor.rgb*=color.rgb;#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;#endif
#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @internal */
export const vertexColorMixing = { name, shader };
